import httpClient from '../httpClient';

const getSelectorCostCenters = async (cost_center_id) => {
  return await httpClient.get(
    `/term_cost_center_selector/?filter[centro_costo]=${cost_center_id}`,
  );
};

const getSelectorProjects = async () => {
  return await httpClient.get(`/term_project_selector`);
};

const getRolesByProject = async (project_id) => {
  return await httpClient.get(
    `/term_role_selector/?filter[proyecto]=${project_id}`,
  );
};

const getDuplicationSelectorProjects = async () => {
  return await httpClient.get(`/term_project_selector/duplication`);
};

const getProjectInfo = async (project_id) => {
  return await httpClient.get(`/terms/${project_id}/project_info/`);
};

const post = async (data) => {
  return await httpClient.post(`/terms/`, data);
};

const getAll = async () => {
  return await httpClient.get(`/terms/?page[size]=1000`);
};

const getTermsByProject = async (projectId) => {
  return await httpClient.get(`/terms/?filter[proyecto]=${projectId}`);
};

const getTermIIDList = async (roleId, params = {}) => {
  return await httpClient.get(
    `/terms/list_selector/?filter[cargo]=${roleId}&page[size]=1000`,
    {
      params: params,
    },
  );
};

const ajaxTable = async (
  query = '',
  page = 1,
  pageSize = 10,
  sortBy = '',
  search = false,
  _exportCSV = false,
) => {
  let searchBy = '';

  if (search) searchBy = '&filter[search]=' + search;
  if (sortBy) sortBy = '&sort=' + sortBy;

  return await httpClient.get(
    `/terms/?page[number]=${page}&page[size]=${pageSize}&${query}${sortBy}${searchBy}`,
  );
};

const duplicate = async (id, target_project) => {
  return await httpClient.post(`/terms/${id}/duplicate/`, {
    proyecto: target_project,
  });
};

const get = async (id) => {
  return await httpClient.get(`/terms/${id}/`);
};

const getChildrenCounter = async (id) => {
  return await httpClient.get(`/terms/${id}/children_counters/`);
};

const interventors = async (project_id) => {
  return await httpClient.get(
    `/terms/interventors/?filter[proyecto]=${project_id}`,
  );
};

const put = async (id, data) => {
  return await httpClient.put(`/terms/${id}/`, data);
};

const remove = async (id) => {
  return await httpClient.delete(`/terms/${id}`);
};

const sendToContract = async (id, data) => {
  return await httpClient.put(`/terms/${id}/send_director/`, data);
};

const getTermAssign = async (id) => {
  return await httpClient.get(`/terms/${id}/term_assign/`);
};

const getTermCounters = async (projectId) => {
  return await httpClient.get(`/terms/counters/?filter[proyecto]=${projectId}`);
};

export {
  getSelectorCostCenters,
  getSelectorProjects,
  getRolesByProject,
  getDuplicationSelectorProjects,
  getProjectInfo,
  post,
  getAll,
  get,
  put,
  remove,
  getTermsByProject,
  getTermIIDList,
  sendToContract,
  duplicate,
  getTermAssign,
  getTermCounters,
  getChildrenCounter,
  interventors,
  ajaxTable,
};
